module.exports = __webpack_public_path__ + "img/shadow.a1454dbb.png";